import { OpenInNew } from '@mui/icons-material';
import { Link, Typography } from '@mui/material';
import React from 'react';
import { resolveExternalOrderLink } from '../../helpers/salesChannels';
import { applyEdges } from '../../helpers/captureMode';

/**
 * Shows external marketplace order id; links out when a panel URL is known.
 */
function ExternalOrderIdDisplay({
    externalOrderId,
    externalOrderUrl,
    salesChannelName,
    prefix = 'ID: ',
    variant = 'body2',
    color = 'text.secondary',
}) {
    const id = String(externalOrderId || '').trim();
    if (!id) {
        return null;
    }

    const href = resolveExternalOrderLink({
        salesChannelName,
        externalOrderId: id,
        externalOrderUrl,
    });

    if (href) {
        return (
            <Typography
                component="span"
                variant={variant}
                color={color}
                sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}
            >
                {prefix}
                <Link
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="hover"
                    sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.35 }}
                >
                    {applyEdges(id)}
                    <OpenInNew sx={{ fontSize: '0.95em' }} />
                </Link>
            </Typography>
        );
    }

    return (
        <Typography component="span" variant={variant} color={color}>
            {prefix}{applyEdges(id)}
        </Typography>
    );
}

export default ExternalOrderIdDisplay;
